<template>
    <a-tag v-if="status==='0'" style="color: #455964;border-color: #455964">未通过</a-tag>
    <a-tag v-if="status==='1'" style="color: #03bbd4;border-color: #03bbd4">待提交</a-tag>
    <a-tag v-if="status==='2'" style="color: #bb6bd0;border-color: #bb6bd0">待审核</a-tag>
    <a-tag v-if="status==='3'" style="color: #FFC018;border-color: #FFC018">已审核</a-tag>
    <a-tag v-if="status==='4'" style="color: #FF0000;border-color: #FF0000">未通过</a-tag>
    <a-tag v-if="status==='5'" style="color: #1890FF;border-color: #1890FF">待补充</a-tag>
    <a-tag v-if="status==='6'" style="color: #008000;border-color: #008000">已完成</a-tag>
    <a-tag v-if="status==='7'" style="color: #ff5500;border-color: #ff5500">待确认</a-tag>
    <a-tag v-if="status==='-1'" style="color: #6d6d6d;border-color: #6d6d6d">已作废</a-tag>
</template>
<script>
export default {
    name: 'ReviewStatus',
    props: ['status'],
}
</script>
<style scoped lang="less">
</style>
